module.exports = __webpack_public_path__ + "img/propertysystem6.d0093be8.png";